import { useEffect, useRef, useCallback } from 'react';
import debounce from 'hs-lodash/debounce';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { usePubSubHealthCheck } from 'conversations-internal-pub-sub/redux/hooks/usePubSubHealthCheck';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { useCheckNetwork } from '../hooks/useCheckNetwork';
import PubSubErrorAlertText from './PubSubErrorAlertText';
import { jsx as _jsx } from "react/jsx-runtime";
const ALERT_DEBOUNCE_MS = 4000;
const PUBSUB_FAILED = 'PUBSUB_FAILED';
const PUBSUB_FAILED_NETWORKERROR = 'PUBSUB_FAILED_NETWORKERROR';
const PUBSUB_RESTORED = 'PUBSUB_RESTORED';
const debouncedShowError = debounce((showingErrorAlert, mobile, isNetworkConnected) => {
  const id = !isNetworkConnected ? PUBSUB_FAILED_NETWORKERROR : PUBSUB_FAILED;
  FloatingAlertStore.addAlert({
    id,
    message: /*#__PURE__*/_jsx(PubSubErrorAlertText, {
      mobile: mobile,
      isNetworkConnected: isNetworkConnected
    }),
    type: 'danger',
    sticky: true
  });
  showingErrorAlert.current = true;
}, ALERT_DEBOUNCE_MS);
const PubSubHealthCheck = ({
  mobile = false
}) => {
  const {
    isFailed,
    isOnline
  } = usePubSubHealthCheck();
  const isNetworkConnected = useCheckNetwork();
  const showingErrorAlert = useRef(false);
  const showReconnectedAlert = useCallback(() => {
    const message = mobile ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.banners.pubSubRestored.mobileMessage"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.banners.pubSubRestored.message"
    });
    FloatingAlertStore.removeAlert(PUBSUB_FAILED);
    FloatingAlertStore.removeAlert(PUBSUB_FAILED_NETWORKERROR);
    FloatingAlertStore.addAlert({
      id: PUBSUB_RESTORED,
      message,
      type: 'success'
    });
    showingErrorAlert.current = false;
  }, [mobile]);
  useEffect(() => {
    if (isFailed) {
      debouncedShowError(showingErrorAlert, mobile, isNetworkConnected);
    } else if (isOnline) {
      debouncedShowError.cancel();
      if (showingErrorAlert.current) {
        showReconnectedAlert();
      }
    }
  }, [isFailed, isOnline, showReconnectedAlert, showingErrorAlert, mobile, isNetworkConnected]);
  return null;
};
export default PubSubHealthCheck;